import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import moment from "moment";
import { Grid, GridItem, Box } from "@sainsburys-tech/fable";
import getAlertFullStatus from "../../model/alerts/getAlertFullStatus";
import formatValue from "./formatValue";
import disconnectedSvg from "../../assets/images/disconnected.svg";
import AlertActiveIndicator from "../AlertActiveIndicator";
import { styles } from "./AlertListItem.styles";

function AlertValueCheck(alertValue, alertType) {
  if (alertValue == null && alertType === "Disconnected") {
    return (
      <img src={disconnectedSvg} alt="Disconnected" height={60} width={60} />
    );
  }
  return formatValue(alertValue);
}

const AlertListItem = ({ alert, redirectTo }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Link
      to={{ 
        pathname: `/alerts/${alert.alertReference}`,
        state: { redirectTo: redirectTo }
      }}
      style={styles.link}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={{
        ...styles.container,
        ...(isHovered && styles.containerHover)
      }}>
        <Grid cols={{ xs: 1, sm: 1, md: 12 }} gap="lg" stack="md">
          {/* Value Section - Left */}
          <GridItem colSpan={{ xs: 1, sm: 1, md: 2 }}>
            <Box style={{
              ...styles.valueContainer,
              ...(isHovered && styles.valueContainerHover)
            }}>
              {AlertValueCheck(alert.value, alert.alertType.code)}
            </Box>
          </GridItem>

          {/* Content Section - Right */}
          <GridItem colSpan={{ xs: 1, sm: 1, md: 10 }}>
            <Grid cols={{ xs: 1, sm: 1, md: 12 }} gap="sm">
              {/* Title Row: Title + Reference + Status */}
              <GridItem colSpan={{ xs: 1, sm: 1, md: 7 }}>
                <div style={styles.titleWrapper}>
                  <h4 style={{
                    ...styles.title,
                    ...(isHovered && styles.titleHover)
                  }}>
                    {alert.alertType.description}
                  </h4>
                  <span style={{
                    ...styles.reference,
                    ...(isHovered && styles.referenceHover)
                  }}>
                    {alert.alertReference}
                  </span>
                </div>
              </GridItem>

              <GridItem colSpan={{ xs: 1, sm: 1, md: 5 }}>
                <div style={{
                  ...styles.status,
                  ...(isHovered && styles.statusHover)
                }}>
                  {`${getAlertFullStatus(alert)}`}
                </div>
              </GridItem>

              {/* Description/Sensor Details */}
              <GridItem colSpan={{ xs: 1, sm: 1, md: 7 }}>
                <div style={{
                  ...styles.sensorDetail,
                  ...(isHovered && styles.sensorDetailHover)
                }}>
                  {alert.sensor.name}, {alert.store.name} ({alert.store.storeId})
                </div>
              </GridItem>

              {/* Indicator + Timestamp - Same Row */}
              <GridItem colSpan={{ xs: 1, sm: 1, md: 7 }}>
                <AlertActiveIndicator alert={alert} isHovered={isHovered} />
              </GridItem>

              <GridItem colSpan={{ xs: 1, sm: 1, md: 5 }}>
                <div style={{
                  ...styles.timestamp,
                  ...(isHovered && styles.timestampHover)
                }}>
                  {`${moment(alert.opened).format("D MMM YY, HH:mm")}`}
                </div>
              </GridItem>
            </Grid>
          </GridItem>
        </Grid>
      </div>
    </Link>
  );
};

AlertListItem.propTypes = {
  alert: PropTypes.object,
  redirectTo: PropTypes.object
};

export default AlertListItem;
